@if (cookieConsentService.consentStatus$ | async; as consent) {
    @if (consent[consentType.Marketing]) {
        @defer (on viewport) {
            <app-meta-live-shopping
                *ngIf="data.scriptUrl"
                [consent]="consentType.Marketing"
                [metaLiveShoppingScriptUrl]="data.scriptUrl"
            ></app-meta-live-shopping>

            <app-iframe-loader *ngIf="data.iFrameURL"
                               [src]="data.iFrameURL"
                               [title]="data.alias"
                               [extraScripts]="data.extraScripts || []"
                               [usePostMessageEvent]="data.usePostMessageEvent || false"
                               [consent]="consentType.Marketing"
                               [iFrameStyle]="data.iFrameStyle"
            ></app-iframe-loader>
        } @placeholder () {
            <p></p>
        }
    } @else {
        <ng-container *ngTemplateOutlet="noConsent"></ng-container>
    }
}

<ng-template #noConsent>
    <app-no-consent [consentType]="consentType.Marketing"></app-no-consent>
</ng-template>
